// extracted by mini-css-extract-plugin
module.exports = {"Container":"Benifits_Container__qSMGe","cards":"Benifits_cards__3qLnk","Card":"Benifits_Card__1o-b2"};